import { IonSpinner } from '@ionic/react';
import React from 'react';
import styled from 'styled-components';
import { t } from 'ttag';

const Container = styled.div`
  background: var(--ion-background-color, #fff);
`;

const Title = styled.h1`
  text-align: center;
  margin-top: 13px;
  margin-bottom: 0px;
  font-size: 22px;
`;

const Flex = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  gap: 40px;
  margin-inline: 20px;
  padding-top: 24px;
  padding-bottom: 20px;
`;

const BlockTitle = styled.h2`
  text-transform: uppercase;
  text-align: center;
  margin-top: 13px;
  font-size: 12px;
  font-weight: 600;
  color: #92949c;
`;

const Count = styled.div`
  font-size: 22px;
`;

interface Props {
  showLoader: boolean;
  showPeopleCount: boolean;
  isSession: boolean;
  isCheckIn: boolean;
  checkInCount?: number;
  checkOutCount?: number;
  peopleCount?: number;
}

const Analytics: React.FC<Props> = ({
  showLoader,
  showPeopleCount,
  isSession,
  isCheckIn,
  checkInCount,
  checkOutCount,
  peopleCount,
}: Props) => {
  let title = isCheckIn ? t`Event Check In` : t`Event Check Out`;
  if (isSession) {
    title = isCheckIn ? t`Session Check In` : t`Session Check Out`;
  }
  return (
    <Container>
      <Title>{title}</Title>
      <Flex>
        <div>
          <BlockTitle>{isCheckIn ? t`Daily Check In` : t`Daily Check Out`}</BlockTitle>
          {showLoader && (
            <IonSpinner
              data-testid="checkin-checkout-count-spinner"
              name="dots"
              style={{ marginBottom: -6 }}
            />
          )}
          {!showLoader && <Count>{isCheckIn ? checkInCount : checkOutCount}</Count>}
        </div>
        {showPeopleCount && (
          <div>
            <BlockTitle>{t`Total People`}</BlockTitle>
            {showLoader && (
              <IonSpinner
                data-testid="people-count-spinner"
                name="dots"
                style={{ marginBottom: -6 }}
              />
            )}
            {!showLoader && <Count>{peopleCount}</Count>}
          </div>
        )}
      </Flex>
    </Container>
  );
};

export default Analytics;
